import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1732586551773'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='5629'
      
    >
        <path
            d='M768 128H256C209.066667 128 170.666667 171.221333 170.666667 224v576C170.666667 852.821333 209.066667 896 256 896h512c46.933333 0 85.333333-43.178667 85.333333-96V224C853.333333 171.221333 814.933333 128 768 128z m-42.666667 426.666667H298.666667v-85.333334h426.666666v85.333334z m-170.666666 170.666666H298.666667v-85.333333h256v85.333333z m170.666666-341.333333H298.666667V298.666667h426.666666v85.333333z'
            fill='currentColor'
            p-id='5630'
        ></path>
    </svg>
)

export const FleetSummaryIcon = props => <Icon component={SVG} {...props} />
